import { ErrorMessage } from "./error";

export type VariantMessageType = "success" | "warning" | "error" | "info";

export class Mensagem {
	show = false;
	variant: VariantMessageType = "info";
	message: string;
}
export const createMessage = (mensagem: string, variant: VariantMessageType): Mensagem => {
	return {
		show: true,
		message: mensagem,
		variant,
	};
};

export const createMessageWarning = (mensagem: string): Mensagem => {
	return createMessage(mensagem, "warning");
};

export const createMessageSuccess = (mensagem: string): Mensagem => {
	return createMessage(mensagem, "success");
};

export const createMessageInfo = (mensagem: string): Mensagem => {
	return createMessage(mensagem, "info");
};

export const createMessageError = (mensagem: string): Mensagem => {
	return createMessage(mensagem, "error");
};


export const createMessageErrorMessage = (error: ErrorMessage): Mensagem => {
	return createMessage(error.message, error.level);
};

export const createMessageErrorCodeMessage = (error: ErrorMessage): Mensagem => {
	return createMessage(`${error.code}-${error.message}`, error.level);
};
